module.exports = __webpack_public_path__ + "media/offers_icons/ciezarowe-white-84b1c5fd.svg";